import { render, staticRenderFns } from "./OrderOffsetForm.vue?vue&type=template&id=4b3c3172"
import script from "./OrderOffsetForm.vue?vue&type=script&lang=ts"
export * from "./OrderOffsetForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports